import { moduleName as rootModuleName } from '../constants';

export const moduleName = 'historyReports';

export const moduleNamespace = `${rootModuleName}/${moduleName}`;
